export const ChevronLeft = ({...rest}) => {
  const style = {fill: 'currentColor', maxWidth: '100%', maxHeight: '100%'};
  return (
    <div {...rest}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
        <path
          d="M16.1314 3.86865C16.7562 4.49349 16.7562 5.50656 16.1314 6.1314L10.2627 12L16.1314 17.8687C16.7562 18.4935 16.7562 19.5066 16.1314 20.1314C15.5065 20.7562 14.4935 20.7562 13.8686 20.1314L6.86863 13.1314C6.24379 12.5066 6.24379 11.4935 6.86863 10.8687L13.8686 3.86865C14.4935 3.24381 15.5065 3.24381 16.1314 3.86865Z"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}